
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductCategoryGrid extends Serenity.EntityGrid<ProductCategoryRow, any> {
        protected getColumnsKey() { return ProductCategoryColumns.columnsKey; }
        protected getDialogType() { return ProductCategoryDialog; }
        protected getIdProperty() { return ProductCategoryRow.idProperty; }
        protected getInsertPermission() { return ProductCategoryRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductCategoryRow.localTextPrefix; }
        protected getService() { return ProductCategoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}